const Projectdata = { data: [], loading: true };
export const GetProjectsReportRed = (state = Projectdata, action) => {
    switch (action.type) {

        case "get_allprojectreport":
            return {
                data: action.payload,
                loading: action.loading
            }
        default:
            return state;
    }


}